import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { take } from 'rxjs/operators';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-padres',
  templateUrl: './padres.component.html',
  styleUrls: ['./padres.component.css'],
})
export class PadresComponent implements OnInit {
  userUid = '';
  userdata: any;
  padres = [];
  uidHijo = '';
  constructor(
    private authenticationService: AuthenticationService,
    private userService: UserService,
    private activatedRoute: ActivatedRoute
  ) {}

  ngOnInit(): void {
    const Userdata: any = this.userService.getUserinfodata();

    if (Userdata === undefined) {
      this.getmainuserdata();
    } else {
      this.userUid = Userdata.payload.doc.data().uid; /* id del usuario */
      this.userdata = Userdata.payload.doc.data();
    }

    this.activatedRoute.params.subscribe((params) => {
      this.uidHijo = params['uid'];
      this.userService
        .getUserByIdNow(this.uidHijo)
        .pipe(take(1))
        .subscribe((userdata) => {
          this.padres = [];
          if (userdata.size > 0) {
            const userdata2: any = userdata.docs[0].data();
            this.getPadres(userdata2.padres);
          }
        });
    });
  }

  /* trae informacion principal del usuario logueado */
  getmainuserdata() {
    this.authenticationService.isAuth().subscribe((auth) => {
      if (auth) {
        this.userUid = auth.uid; /* id del usuario */

        this.authenticationService
          .isUserAdmin(this.userUid)
          .subscribe((userdata) => {
            if (userdata[0]) {
              this.userdata = userdata[0];
            }
          });
      }
    });
  }

  getPadres(padresUids) {
    padresUids.forEach((uid) => {
      this.userService
        .getUserByIdNow(uid)
        .pipe(take(1))
        .subscribe((userdata) => {
          console.log('userdatapadre', userdata.docs[0].data());
          this.padres = [];
          if (userdata.size > 0) {
            const userdata2: any = userdata.docs[0].data();
            const chaturl = [userdata2.uid, this.userUid].sort().join('|');
            const datosPadre = {
              chaturl: chaturl,
              datos: userdata2,
            }
            this.padres.push(datosPadre);
          }
        });
    });
  }
}
